//import external libraries
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useContext } from "react";
import "animate.css";

//import internal resources and services
import ProjectItemsTable from "./ProjectItemsTable";
import ProjectCard from "../ProjectCard";
import ProjectItemsHydraTable from "../projectItemHydra/ProjectItemsTableHydra";
import UnitTypeSelector from "../UnitTypeSelector";
import { deleteProject } from "../../../utils/services/projectService";
import {
  getProject,
  getProjectByAdmin,
} from "../../../utils/services/projectService";
import { setSnackbar } from "../../../actions/snackbarActions";
import { useParams } from "react-router-dom";
//import MUI components
import Divider from "@mui/material/Divider";
import ArticleIcon from "@mui/icons-material/Article";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";

function ProjectItem() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { projectId } = useParams();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openUnitTypeSelector, setOpenUnitTypeSelector] = useState(false);
  const [rowsChanged, setRowsChanged] = useState(false);

  const [searchParams] = useSearchParams();
  const projNumber = searchParams.get("projectNumber") || "AHU1";
  const projName = searchParams.get("projectName") || "";

  const projIdent = 123;
  const projDepartment = "location.state.department;";

  const [project, setProject] = useState({
    projId: projectId,
    number: "",
    costDriver: "",
    name: "",
    country: "",
    address: "",
    //summer
    summerOutdoorTemperature: 0,
    summerWetBulbTemperature: 0,
    summerDewPointTemperature: 0,
    summerOutdoorHumidity: 0,
    //winter
    winterOutdoorTemperature: 0,
    winterOutdoorHumidity: 0,
    elevation: 0,
    elPriceBusiness: 0,
    elPriceHome: 0,
    status: "",
    aqiCurrent: 0,
    aqiYearlyAverage: 0,
    aqiQualityGood: 0,
    aqiQualityModerate: 0,
    aqiQualitySensitive: 0,
    aqiQualityUnhealthy: 0,
    aqiQualityUnhealthyV: 0,
    aqiQualityHazardous: 0,
  });
  const [customer, setCustomer] = useState({
    name: "",
    representative: "",
    email: "",
    phone: "",
    erpId: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteProj = (e) => {
    deleteProject(projectId)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          dispatch(
            setSnackbar(
              true,
              "success",
              t("snackbar.deleteProjectSuccess"),
              "/"
            )
          );
        } else {
          dispatch(
            setSnackbar(true, "error", t("snackbar.deleteProjectError"))
          );
        }
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", t("snackbar.deleteProjectError")));
      });

    handleClose();
  };

  useEffect(() => {
    if (
      !location?.state?.hasOwnProperty("prevLocation")
      //&& location.state.prevLocation !== "/adminPanel"
    ) {
      getProject(projectId).then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          let p = response.data;

          let c = response.data.customer
            ? response.data.customer
            : {
                name: "",
                representative: "",
                email: "",
                phone: "",
                erpId: "",
              };
          setProject({
            number: p.number,
            projectName: p.name,
            createdAt: p.createdAt,
            timeZone: p.timeZone,
            country: p.country,
            address: p.address,
            city: p.city,
            numberOfUnits: p.numberOfUnits,
            totalPrice: p.totalPrice,
            summerOutdoorTemperature: p.summerOutdoorTemperature,
            summerWetBulbTemperature: p.summerWetBulbTemperature,
            summerDewPointTemperature: p.summerDewPointTemperature,
            summerOutdoorHumidity: p.summerOutdoorHumidity,
            winterOutdoorTemperature: p.winterOutdoorTemperature,
            winterOutdoorHumidityRatio: p.winterOutdoorHumidityRatio,
            elevation: p.elevation,
            winterOutdoorHumidity: p.winterOutdoorHumidity,
            elPriceBusiness: p.elPriceBusiness,
            elPriceHome: p.elPriceHome,
            status: p.status,
            aqiCurrent: p.aqiCurrent,
            aqiYearlyAverage: p.aqiYearlyAverage,
          });
          setCustomer({
            name: c.name,
            representative: c.representative,
            email: c.email,
            phone: c.phone,
            erpId: c.erpId,
          });
          setLoading(false);
        }
      });
    } else {
      getProjectByAdmin(projectId).then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          let p = response.data;
          setProject({
            number: p.number,
            projectName: p.name,
            createdAt: p.createdAt,
            timeZone: p.timeZone,
            country: p.country,
            address: p.address,
            city: p.city,
            numberOfUnits: p.numberOfUnits,
            totalPrice: p.totalPrice,
            summerOutdoorTemperature: p.summerOutdoorTemperature,
            summerWetBulbTemperature: p.summerWetBulbTemperature,
            summerDewPointTemperature: p.summerDewPointTemperature,
            summerOutdoorHumidity: p.summerOutdoorHumidity,
            winterOutdoorTemperature: p.winterOutdoorTemperature,
            winterOutdoorHumidityRatio: p.winterOutdoorHumidityRatio,
            elevation: p.elevation,
            winterOutdoorHumidity: p.winterOutdoorHumidity,
            elPriceBusiness: p.elPriceBusiness,
            elPriceHome: p.elPriceHome,
            status: p.status,
            aqiCurrent: p.aqiCurrent,
            aqiYearlyAverage: p.aqiYearlyAverage,
          });
          setLoading(false);
        }
      });
    }
  }, [projectId, rowsChanged]);

  const editProj = (e) => {
    window.scrollTo(0, 0);
    navigate("/edit", { state: { projId: projectId } });
  };

  const createProjectConfigurator = (e) => {
    e.preventDefault();
    window.scroll(0, 0);
    setOpenUnitTypeSelector(true);
  };

  const handleCloseUnitTypeSelector = () => {
    setOpenUnitTypeSelector(false);
  };

  return !loading ? (
    <Container component="main" maxWidth sx={{ marginBottom: "0px" }}>
      <Box sx={{ mt: 1 }}>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <ArticleIcon sx={{ width: 50, height: 50, m: 1 }} />
          <Typography
            component="h1"
            variant="h5"
            sx={{ margin: 2, fontSize: "32px" }}
          >
            {t("projectitem.infoprojectinfo")} {project.projectName}
          </Typography>{" "}
          <Box sx={{ flex: "1", textAlign: "right", paddingRight: "35px" }}>
            <Button onClick={(e) => editProj(e)}>
              <EditIcon sx={{ color: theme.palette.primary.main }} />
            </Button>
            <Button onClick={handleClickOpen}>
              {" "}
              <DeleteIcon sx={{ color: theme.palette.primary.main }} />
            </Button>
            <Dialog
              disableScrollLock={true}
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{ sx: { padding: "10px 20px" } }}
              sx={{ backdropFilter: "blur(5px)" }}
            >
              <DialogTitle id="alert-dialog-title" sx={{ fontSize: "30px" }}>
                {t("projectitem.dialogTitleProject")}
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  sx={{ fontSize: "20px", color: "#222" }}
                >
                  {t("projectitem.dialogContentTextProject")}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  sx={{
                    fontSize: "18px",
                    marginRight: "5px",
                    padding: "2px",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.9)",
                      color: "#80caef",
                    },
                  }}
                >
                  {t("projectitem.buttonNo")}
                </Button>
                <Button
                  onClick={(e) => deleteProj(e)}
                  autoFocus
                  variant="outlined"
                  sx={{
                    fontSize: "18px",
                    padding: "2px",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.9)",
                      color: theme.palette.secondary.main,
                    },
                  }}
                >
                  {t("projectitem.buttonYes")}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ mb: 3 }} />
      <ProjectCard
        number={project.number}
        projectName={project.projectName}
        createdAt={project.createdAt}
        timeZone={project.timeZone}
        country={project.country}
        address={project.address}
        city={project.city}
        numberOfUnits={project.numberOfUnits}
        totalCosts={project.totalPrice}
        summerOutdoorTemperature={project.summerOutdoorTemperature}
        summerWetBulbTemperature={project.summerWetBulbTemperature}
        summerDewPointTemperature={project.summerDewPointTemperature}
        summerOutdoorHumidity={project.summerOutdoorHumidity}
        winterOutdoorTemperature={project.winterOutdoorTemperature}
        winterOutdoorHumidity={project.winterOutdoorHumidity}
        elPriceBusiness={project.elPriceBusiness}
        elPriceHome={project.elPriceHome}
        status={project.status}
        aqiCurrent={project.aqiCurrent}
        aqiYearlyAverage={project.aqiYearlyAverage}
        elevation={project.elevation}
        winterOutdoorHumidityRatio={project.winterOutdoorHumidityRatio}
        erpId={customer.erpId}
        customerName={customer.name}
        customerRepresentative={customer.representative}
        customerEmail={customer.email}
        customerPhone={customer.phone}
      />

      <Divider sx={{ mb: 3, mt: 3 }} />
      <Box
        sx={{
          m: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "20vh",
        }}
      >
        <Button
          variant="contained"
          onClick={(e) => createProjectConfigurator(e)}
          className="animate__animated animate__flash animate__repeat-1 animate__delay-1s animate__slow"
          sx={{
            mt: 2,
            mb: 2,
            backgroundColor: "#5cc1f1",
            color: "white",
            padding: "8px 40px",
            fontSize: 26,
            transition: "all 0.5s",
            "&:hover": {
              backgroundColor: "#4a9bc7",
              transform: "scale(1.05)",
            },
          }}
        >
          {t("projectitem.addposition")}
        </Button>
      </Box>

      <Box sx={{ height: "40%", mb: 1 }}></Box>

      <ProjectItemsTable
        projectId={projectId}
        projectNumber={projNumber}
        projectName={projName}
        projectIdent={projIdent}
        projectDepartment={projDepartment}
        admin={
          location?.state?.hasOwnProperty("prevLocation") &&
          location.state.prevLocation === "/adminPanel"
        }
        rowsChanged={rowsChanged}
        setRowsChanged={setRowsChanged}
      ></ProjectItemsTable>

      <ProjectItemsHydraTable projectId={projectId} />

      {/* Unit Type Selector Dialog */}
      <Dialog
        open={openUnitTypeSelector}
        onClose={handleCloseUnitTypeSelector}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            maxHeight: "90vh",
            overflow: "auto",
          },
        }}
        sx={{ backdropFilter: "blur(5px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 2,
          }}
        >
          <Typography variant="h5" component="h2">
            {t("projectitem.addposition")}
          </Typography>
          <IconButton
            onClick={handleCloseUnitTypeSelector}
            sx={{
              color: theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          <UnitTypeSelector onClose={handleCloseUnitTypeSelector} />
        </DialogContent>
      </Dialog>
    </Container>
  ) : (
    <Box sx={{ width: "100%", height: "75vh" }}>
      <Stack
        spacing={1}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Skeleton
          variant="rectangular"
          sx={{ width: "60vw", height: "30vh", mt: "5%", mb: "2%" }}
        />

        <Skeleton
          variant="rectangular"
          sx={{ width: "10%", height: "5vh", mb: "2%" }}
        />

        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
        <Skeleton variant="rectangular" sx={{ width: "100%", height: "5vh" }} />
      </Stack>
    </Box>
  );
}

export default ProjectItem;
